export default __webpack_public_path__ + "static/media/LSP5.78ca6586.jpeg";